import styled from 'styled-components';
import { Pagination } from 'react-bootstrap';

export const PaginationStyled = styled(Pagination)``;
